<template>
    <div class="fw-jddsh">
        <div class="sousuo">
            <div class="sou-item">
                <van-search
                        v-model="phone"
                        placeholder="请输入手机号搜索"
                        shape="round"
                >
                </van-search>
            </div>
        </div>
        <Cxdate @chaxun="chaxun"/>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
            <div class="jd-items" v-for="(item,index) in list">
                    <div class="mbinfo">
                        <div>
                            <img v-if="item.headPortrait" :src="item.headPortrait" class="my-tou"/>
                            <div v-else>
                                <img v-if="item.sex==0" src="src/assets/nan.png" class="my-tou"/>
                                <img v-if="item.sex==1" src="src/assets/nan.png" class="my-tou"/>
                                <img v-if="item.sex==2" src="src/assets/nv.png" class="my-tou"/>
                            </div>
                        </div>
                        <div class="my-mbinfo">
                            <span style="font-size: 13px;height: 20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;margin-left: 10px">{{item.memberName}}</span>
                            <span style="font-size: 10px;margin-left: 8px">
                                        <span style="background-color: gainsboro;padding: 0 10px;">{{item.lvName==null?'PLUS: 未开通':item.lvName}}</span>
                                    </span>
                        </div>
                    </div>
                    <div class="jdinfo">
                        <div class="jdbt">
                            <span style="font-size: 15px;margin-bottom: 8px">充值金豆</span>
                            <span style="font-size: 9px;color: #AAAAAA">{{item.createTime}}</span>
                        </div>
                        <span style="color:#F68C42;font-size: 15px">¥{{item.total}}</span>
                    </div>
                <div class="shbtn">
                    <div style="display: flex">
                                <span v-if="item.reviewStatus==1" class="spbtn1"
                                      @click="caozuo(item,2,index)">通过</span>
                        <span v-if="item.reviewStatus==1" class="spbtn2"
                              @click="caozuo(item,3,index)">拒绝</span>
                        <!--                                <span v-if="item.reviewStatus==3" class="spbtn2" @click="caozuo(item,4,index)">删除</span>-->
                    </div>
                    <div style="margin-top: -3px">
                        <span v-if="item.reviewStatus==1" style="color: #2b94ff">待审核</span>
                        <span v-if="item.reviewStatus==2" style="color: #67c23a">通过</span>
                        <span v-if="item.reviewStatus==3" style="color: #f56c6c">拒绝</span>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import {getCookie,} from "../../../utils/auth";
    import Cxdate from "../../common/cxdate.vue";
    export default {
        components: {Cxdate},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',

                dateType: 0,
                staDate: '',
                endDate: '',
                phone:'',
                list: [],
                loading: false,
                finished: false,
                page: 1,
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            // this.userType = this.fwUser.userType
        },
        methods: {
            chaxun(data) {
                this.dateType = data.dateType
                this.staDate = data.staDate
                this.endDate = data.endDate
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            onSearch() {
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            async onLoad() {
                let currentPage = this.page || 1;
                let data = {
                    token: this.token,
                    dateType:this.dateType,
                    staDate :this.staDate,
                    endDate :this.endDate,
                    phone :this.phone,
                    reviewStatus:1,
                    currentPage
                }
                let res = await this.$get("/fw/getFwMemberBeanPage", data)
                if (res.code == 200) {
                    const count =res.dataSet.list.length
                    const newList =res.dataSet.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.list = this.quchong(list,"id")
                    }else {
                        this.list =list
                    }
                    this.page=this.page+1
                    this.loading = false
                    if (count<10&&count==0){
                        this.finished = true
                    }
                }else {
                    this.finished = true
                }
            },
            caozuo(item, type,index) {
                let that = this
                that.$dialog.confirm({
                    title: '标题',
                    message: '确认操作?'
                }).then(() => {
                    if (type == 2) {
                        that.updateMemberBean(item,type,index)
                    }
                    if (type == 3) {
                        that.updateMemberBean(item,type,index)
                    }
                    if (type == 4) {
                        that.delMemberBean(item,index)
                    }
                }).catch(() => {
                    // on cancel
                });
            },
            async updateMemberBean(item,type,index) {
                let data = {
                    id: item.id,
                    reviewStatus:type,
                    token:this.token,
                }
                let res = await this.$post("/fw/updateFwMemberBean", data)
                if (res.code==200){
                    this.list[index].reviewStatus=type
                    this.$notify({type: 'success', message: res.message});
                }else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            // async delMemberBean(item) {
            //     let data = {
            //         id: item.id,
            //     }
            //     let res = await this.$get("/fw/delFwMemberBean", data)
            //     if (res.code==200){
            //         this.jdList.slice(index,1)
            //         this.$notify({type: 'success', message: res.message});
            //     }else {
            //         this.$notify({type: 'danger', message: res.message});
            //     }
            // },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-jddsh {
    }
    .mbinfo {
        display: flex;
        flex-direction: row;
        padding: 10px;
    }

    .my-tou {
        height: 40px;
        width: 40px;
    }

    .my-mbinfo {
        display: flex;
        flex-direction: column;
    }

    .jd-items {
        padding: 10px;
        margin-top: 5px;
        background-color: #FFFFFF;
    }

    .jdinfo {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 8px 10px;
        margin-bottom: 10px;
    }

    .jdbt {
        display: flex;
        flex-direction: column;
    }

    .shbtn {
        display: flex;
        flex-direction: row;
        font-size: 13px;
        height: 18px;
        line-height: 18px;
        justify-content: space-between;
        margin: 13px 10px;
    }

    .spbtn1 {
        display: inline-block;
        padding: 0 10px;
        margin-right: 15px;
        color: #FFFFFF;
        background-color: #2b94ff;
        font-size: 11px;
    }

    .spbtn2 {
        display: inline-block;
        padding: 0 10px;
        color: #FFFFFF;
        background-color: #f56c6c;
        font-size: 11px;
    }

    .sousuo {
        background-color: #FFFFFF;
        padding-top: 10px;
    }

    .sou-item {
        padding: 0 28px;
    }

</style>